import {register} from '../locale';

register('en-US', {
  'Action.countDown': 'Wait for ${timeLeft}s',
  'Alert.info': 'System Info',
  'asc': 'Asc',
  'cancel': 'Cancel',
  'Card.dragTip': 'Drag top button to sort',
  'Card.toggleDrag': 'Toggle drag to sort',
  'City.street': 'Enter street info',
  'clear': 'Clear',
  'ColorPicker.placeholder': 'Select color',
  'Combo.add': 'New',
  'Combo.dragDropSort': 'Drag to sort',
  'Combo.invalidData': 'invalid data, please remove',
  'Combo.maxLength': 'Maximum item ia {{MaxLength}}}. Please delete some',
  'Combo.minLength': 'A least {{minLength}} item. Please add more',
  'Combo.type': 'Type',
  'confirm': 'Confirm',
  'Copyable.tip': 'Copy',
  'CRUD.exportCSV': 'Export CSV',
  'CRUD.exportExcel': 'Export Excel',
  'CRUD.fetchFailed': 'Fetch failed',
  'CRUD.filter': 'Filter',
  'CRUD.selected': 'selected items: ',
  'CRUD.invalidArray': 'data.items must be an array',
  'CRUD.invalidData': 'data is empty',
  'CRUD.loadMore': 'Load more',
  'CRUD.perPage': 'Per page',
  'CRUD.stat': '{{page}} of {{lastPage}} total: {{total}}.',
  'CRUD.paginationGoText': 'Go to',
  'CRUD.paginationPageText': 'page',
  'PaginationWrapper.placeholder': 'please config body',
  'Date.daysago': '{{days}} day(s) ago',
  'Date.dayslater': '{{days}} day(s) later',
  'Date.endOfMonth': 'last day of the month',
  'Date.endOfLastMonth': 'last day of last month',
  'Date.endOfWeek': 'Saturday',
  'Date.hoursago': '{{hours}} hour(s) ago',
  'Date.hourslater': '{{hours}} hour(s) later',
  'Date.invalid': 'Invalid date',
  'Date.monday': 'Monday',
  'Date.monthsago': '{{months}} month(s) ago',
  'Date.monthslater': '{{months}} month(s) later',
  'Date.now': 'Now',
  'Date.placeholder': 'Select Date',
  'Date.quartersago': '{{quarters}} quarter(s) ago',
  'Date.quarterslater': '{{quarters}} quarter(s) later',
  'Date.startOfLastMonth': 'First day of the last month',
  'Date.startOfLastQuarter': 'First day of the last quarter',
  'Date.startOfMonth': 'First day of the month',
  'Date.startOfQuarter': 'First day of the quarter',
  'Date.today': 'Today',
  'Date.tomorrow': 'Tomorrow',
  'Date.weeksago': '{{weeks}} week(s) ago',
  'Date.weekslater': '{{weeks}} week(s) later',
  'Date.yesterday': 'Yesterday',
  'dateformat.year': 'YYYY',
  'DateRange.1daysago': '1 day ago',
  'DateRange.7daysago': '7 days ago',
  'DateRange.30daysago': '30 days ago',
  'DateRange.90daysago': '90 days ago',
  'DateRange.lastMonth': 'Last month',
  'DateRange.lastWeek': 'Last week',
  'DateRange.lastQuarter': 'Last quarter',
  'DateRange.placeholder': 'Select a Date range',
  'DateRange.thisWeek': 'This Week',
  'DateRange.thisMonth': 'This month',
  'DateRange.thisQuarter': 'This quarter',
  'DateRange.valueConcat': ' to ',
  'DateTime.placeholder': 'Select Datetime',
  'delete': 'Delete',
  'deleteConfirm': 'Are your sure to delete?',
  'deleteFailed': 'Delete failed',
  'desc': 'Desc',
  'Dialog.close': 'Close',
  'fetchFailed': 'Fetch api failed',
  'File.continueAdd': 'Continue add',
  'File.dragDrop': `Drag 'n' drop some files here`,
  'File.errorRetry': 'File upload failed, please try again',
  'File.failed': 'Failed files.',
  'File.invalidType': '{{files}} does not match type `{{accept}}`',
  'File.maxSize': '{{filename}} you selected exceeds the maximum limit of {{maxsize}} (in bytes)',
  'File.pause': 'Pause uplaod',
  'File.repick': 'Repick',
  'File.result': 'Successfully uploaded {{uploaded}} files, failed to upload {{failed}} files',
  'File.retry': 'Retry',
  'File.start': 'Start upload',
  'File.upload': 'Upload',
  'File.uploadFailed': 'return data of udpload api is empty',
  'File.uploading': 'Uploading',
  'Form.loadOptionsFailed': 'Failed to load options because: {{reason}}',
  'Form.submit': 'Submit',
  'Form.title': 'Form',
  'Form.unique': 'Current value is not unique',
  'Form.validateFailed': 'Form input validation failed',
  'Image.configError': 'Can only set one of crop or multiple',
  'Image.crop': 'Crop image',
  'Image.dragDrop': `Drag 'n' drop some photos here`,
  'Image.height': 'height: {{height}}px',
  'Image.limitMax': 'Minimum image size is {{info}}',
  'Image.limitMin': 'Maximum image size is {{info}}',
  'Image.limitRatio': 'Please upload image with the size ratio of {{ration}}',
  'Image.pasteTip': 'You can paste image from the clipboard',
  'Image.placeholder': 'Click to select image or drag into this area',
  'Image.size': 'size: ({{width}}px x {{height}}px)',
  'Image.sizeNotEqual': 'The image you selected does not meet the size requirements {{info}}',
  'Image.width': 'width: {{width}}px',
  'Image.zoomIn': 'Zoom In',
  'Log.mustHaveSource': 'Must have source in config',
  'link': 'Link',
  'loading': 'Loading',
  'LocationPicker.placeholder': 'Pick location',
  'Month.placeholder': 'Select a month',
  'Nav.sourceError': 'Fetch link error',
  'networkError': 'Network error or missing CORS configuration',
  'noResult': 'No Result',
  'NumberInput.placeholder': 'Please enter a number',
  'Options.addPlaceholder': 'Please enter a name',
  'Options.deleteAPI': 'Must have deleteAPI',
  'Options.editLabel': 'Edit {{label}}',
  'Options.label': 'option',
  'placeholder.empty': '<Empty>',
  'placeholder.enter': 'Enter',
  'placeholder.noData': 'No data',
  'placeholder.noOption': 'No option',
  'placeholder.selectData': 'Select data',
  'Quarter.placeholder': 'Select a quarter',
  'Repeat.pre': 'Per',
  'reset': 'Reset',
  'saveFailed': 'Save failed',
  'saveSuccess': 'Saved successfully',
  'search': 'Search',
  'searchResult': 'Search result',
  'Select.checkAll': 'Check all',
  'Select.clear': 'Clear',
  'Select.clearAll': 'Clear all',
  'Select.createLabel': 'New option',
  'Select.placeholder': 'Select',
  'Select.searchPromptText': 'Input to search',
  'sort': 'Sort',
  'SubForm.button': 'Config',
  'SubForm.editDetail': 'Edit Detail',
  'Table.addRow': 'Add a row',
  'Table.columnsVisibility': 'Click to control columns visibility',
  'Table.deleteRow': 'Delete current row',
  'Table.discard': 'Discard',
  'Table.dragTip': 'Drag the button on the left to sort',
  'Table.editing': 'You should finished editing',
  'Table.editRow': 'Edit current row',
  'Table.modified': 'There are {{modified}} records have been modified, you can:',
  'Table.moved': 'There are {{moved}} records changed the order, you can:',
  'Table.operation': 'Operation',
  'Table.playload': 'Must have playload',
  'Table.startSort': 'Click to start sorting',
  'Table.valueField': 'Must have valueField',
  'Tag.placeholder': 'No tag yet',
  'Tag.tip': 'Recently used tag',
  'Text.add': 'New {{label}}',
  'Time.placeholder': 'Select Time',
  'Transfer.configError': 'Config error',
  'Transfer.refreshIcon': 'Click to refresh',
  'Transfer.searchKeyword': 'Enter keywords',
  'Transfer.selectd': 'Selected',
  'Transfer.selectFromLeft': 'Select from the left',
  'Tree.addChild': 'Add child',
  'Tree.addRoot': 'Add root node',
  'Tree.editNode': 'Edit this node',
  'Tree.removeNode': 'Remove this node',
  'Tree.root': 'Root',
  'validate.equals': 'value must be $1',
  'validate.equalsField': 'value must be $1',
  'validate.gt': 'Please enter a value greater than $1',
  'validate.isAlpha': 'Please enter letters',
  'validate.isAlphanumeric': 'Please enter letters or numbers',
  'validate.isEmail': 'Email format is incorrect',
  'validate.isFloat': 'Please enter a floating point value',
  'validate.isId': 'invalid ID Card number',
  'validate.isInt': 'Please enter an integer number',
  'validate.isJson': 'invalid JSON format.',
  'validate.isLength': 'Please make sure the length of contents is $1',
  'validate.isNumeric': 'Please enter a number',
  'validate.isPhoneNumber': 'invalid phone number',
  'validate.isRequired': 'This is required',
  'validate.isTelNumber': 'invalid telephone number',
  'validate.isUrl': 'Incorrect URL format',
  'validate.isUrlPath': 'You can only enter letters, numbers, `-` and`_` .',
  'validate.isWords': 'Please enter word',
  'validate.isZipcode': 'invalid postal address',
  'validate.lt': 'Please enter a value less than $1',
  'validate.matchRegexp': 'The format is not correct. Please enter the content with the rule `${1| raw}`.',
  'validate.maximum': 'The input value exceeds the maximum value of $1',
  'validate.maxLength': 'Please control the content length, do not enter more than $1 letters',
  'validate.minimum': 'The input value is lower than the minimum value of $1',
  'validate.minLength': 'Please enter more, at least $1 characters.',
  'validate.notEmptyString': 'Please do not enter all blank characters',
  'validateFailed': 'Validate failed,',
  'Wizard.configError': 'Config error',
  'Wizard.finish': 'Finish',
  'Wizard.next': 'Next',
  'Wizard.prev': 'Prev',
  'Wizard.saveAndNext': 'Save & Next',
  'year-to-year': '{{from}} - {{to}}',
  'Year.placeholder': 'Select a Year'
});
